module.exports = __webpack_public_path__ + "img/image.cf8862d8.svg";